import "./ArchiveProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ArchiveTitleSection from "./sections/ArchiveTitleSection"
import Shop from "./sections/Shop"
import Footer from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <Header />
      <ArchiveTitleSection />
      <Shop />
      <Footer />
    </div>
  )
}
